const styles = {
    errorMessage: {
        width: '100%', textAlign: 'left', maxWidth: '800px', margin: 'auto',
    }
}

export default styles;